module.exports = __webpack_public_path__ + "static/media/footerTopBg.69cb2799.png";